import { isHTMLElement } from "./elementTests.js";
import { getLevelSelector } from "./selectorHelpers.js";

/**
 * Get the next row in the table
 *
 * @param element The current row
 * @returns The next row in the table or null if there is no next row.
 */
export function getNextRow(element: ChildNode): HTMLElement | null {
	let next = element.nextSibling;
	while (next) {
		if (isHTMLElement(next)) {
			return next;
		}
		next = next.nextSibling;
	}
	return null;
}

/**
 * Gets all the rows at the given level.
 *
 * @param element The element to search
 * @param level The level to search
 * @returns All the rows at the given level.
 */
export function getLevel(
	element: HTMLElement,
	level: number,
): NodeListOf<HTMLTableRowElement> {
	return element.querySelectorAll<HTMLTableRowElement>(getLevelSelector(level));
}
